module.exports = __webpack_public_path__ + "static/close-icon-gray.786f1167.png";